import { useEffect, useRef, useState } from "react";

/**
 * Tracks dirty state vs a JSON baseline and warns on page unload.
 * Call markClean() after a successful save. Pass ready=true once initial data is loaded.
 */
export default function useUnsavedGuard(data, { ready = true } = {}) {
  const [baseline, setBaseline] = useState(null);
  const wasReady = useRef(false);

  useEffect(() => {
    if (ready && !wasReady.current) {
      setBaseline(JSON.stringify(data ?? {}));
      wasReady.current = true;
    }
    if (!ready) {
      wasReady.current = false;
      setBaseline(null);
    }
  }, [ready]); // eslint-disable-line react-hooks/exhaustive-deps

  const dirty = baseline !== null && JSON.stringify(data ?? {}) !== baseline;

  useEffect(() => {
    const onLeave = (e) => {
      if (!dirty) return;
      e.preventDefault();
      e.returnValue = "";
    };
    window.addEventListener("beforeunload", onLeave);
    return () => window.removeEventListener("beforeunload", onLeave);
  }, [dirty]);

  const markClean = (nextData = data) => {
    setBaseline(JSON.stringify(nextData ?? {}));
  };

  return { dirty, markClean };
}
